import { useTheme } from "../hooks/useTheme";
import reactIcon from "../assets/react-svgrepo-com.svg";
import nodejsIcon from "../assets/nodejs-svgrepo-com.svg";
import typescriptIcon from "../assets/typescript-16-svgrepo-com.svg";
import ethereumIcon from "../assets/ethereum-svgrepo-com.svg";
import mongodbIcon from "../assets/mongodb-svgrepo-com.svg";
import solidityIcon from "../assets/light-solidity-svgrepo-com.svg";
import mysqlIcon from "../assets/mysql-svgrepo-com.svg";
import postgresIcon from "../assets/postgresql-svgrepo-com.svg";
import godotIcon from "../assets/godot-engine-svgrepo-com.svg";

const Technologies = () => {
  const { isDarkMode } = useTheme();

  const technologies = [
    {
      name: "React",
      svg: (
        <img
          src={reactIcon}
          alt="React JavaScript library for web development"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "Node.js",
      svg: (
        <img
          src={nodejsIcon}
          alt="Node.js backend development runtime"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "TypeScript",
      svg: (
        <img
          src={typescriptIcon}
          alt="TypeScript programming language"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "Godot",
      svg: (
        <img
          src={godotIcon}
          alt="Godot game development engine"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "Ethereum",
      svg: (
        <img
          src={ethereumIcon}
          alt="Ethereum blockchain platform"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "MongoDB",
      svg: (
        <img
          src={mongodbIcon}
          alt="MongoDB NoSQL database"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "Solidity",
      svg: (
        <img
          src={solidityIcon}
          alt="Solidity smart contract language"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "MySQL",
      svg: (
        <img
          src={mysqlIcon}
          alt="MySQL relational database"
          className="h-full w-auto"
        />
      ),
    },
    {
      name: "PostgreSQL",
      svg: (
        <img
          src={postgresIcon}
          alt="PostgreSQL database management system"
          className="h-full w-auto"
        />
      ),
    },
  ];

  return (
    <section
      id="technologies"
      className="py-16 sm:py-20 md:py-24 lg:py-28 relative"
      aria-labelledby="technologies-heading"
    >
      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20 relative z-10">
        <header className="w-full text-center mb-12 sm:mb-16 block">
          <h2
            id="technologies-heading"
            className={`text-l sm:text-xl lg:text-2xl font-medium mx-auto w-full transition-colors duration-700 ${
              isDarkMode ? "text-white" : "text-graphite-medium"
            }`}
          >
            Expert in Modern Development Technologies
          </h2>
        </header>

        <div
          className="flex flex-wrap justify-center items-center gap-6 sm:gap-8 md:gap-12 lg:gap-16 xl:gap-20"
          role="list"
        >
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="opacity-70 hover:opacity-100 transition-opacity duration-300 h-8 sm:h-10 md:h-12 lg:h-14 xl:h-16"
              title={tech.name}
              role="listitem"
            >
              <div
                className={`h-full flex items-center justify-center transition-all duration-700 ${
                  isDarkMode ? "brightness-0 invert" : "brightness-0"
                }`}
              >
                {tech.svg}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;
